import { useInstitutionContext } from "@hooks/institutionContext";
import styles from "./EnvironmentBanner.module.css";
import { useUserConfiguration } from "@hooks/useUserConfiguration";

type Environment = "Production" | "UAT" | "Development";

export const EnvironmentBanner = () => {
  const { institution } = useInstitutionContext();
  const { roles } = useUserConfiguration();
  const { is_demo, is_uat, is_production, release_version } = institution;

  if (is_demo || (is_production && !roles.narmi)) return null;

  const environment: Environment = is_production ? "Production" : is_uat ? "UAT" : "Development";
  const message =
    environment === "Development"
      ? `${environment} environment` // release_version is "dev" locally so it is redundant
      : `${environment} environment - ${release_version}`;

  return (
    <div className={styles.banner}>
      <div className={styles.bannerContent}>
        <i className={`narmi-icon-alert-circle ${styles.bannerIcon}`} />
        <p className={styles.bannerText}>{message}</p>
      </div>
    </div>
  );
};
